import type { SxProps, Theme } from '@mui/material'

type SxArray = Extract<SxProps<Theme>, ReadonlyArray<unknown>>
/** One entry of MUI's array form, `boolean` included — that is its conditional-`sx` idiom. */
type SxEntry = SxArray[number]

/**
 * TypeScript types `Array.isArray` as `(arg: any) => arg is any[]`, so testing a union whose member
 * is a `ReadonlyArray` widens it to `any[]` instead of narrowing it. Naming the member keeps it.
 */
const isSxArray = (value: SxProps<Theme>): value is SxArray => Array.isArray(value)

const toEntries = (value: SxProps<Theme>): readonly SxEntry[] =>
  isSxArray(value) ? value : [value]

/**
 * Merges a component's own `sx` with an override a caller passed in, following MUI's documented
 * array form, so every component that accepts an override spreads it here rather than inline.
 * Either side may already be an array, and both are flattened one level.
 */
export const mergeSx = (base: SxProps<Theme>, override?: SxProps<Theme>): SxEntry[] => [
  ...toEntries(base),
  ...(override === undefined ? [] : toEntries(override)),
]
